import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Typography, DialogContentText, Divider, MenuItem, Grid, InputLabel, TextField, TableCell, TableRow, TableContainer, TableBody, Table, TableHead } from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import DeleteIcon from '@material-ui/icons/Delete';
import tokenDecoder from '../../../utils/tokenDecoder';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { CustomMultiSelect } from 'src/utils/CustomMultiSelect';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    table: {
        minWidth: 550,
    },
}));

const screenCode = "WAREHOUSESKUMAPPING"
export default function WarehouseSKUMappingAddEdit() {
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    const [title, setTitle] = useState("Add Warehouse SKU Mapping");
    const [groups, setGroups] = useState();
    const [purchaseCategories, setPurchaseCategories] = useState();
    const [factories, setFactories] = useState([]);
    const [budgetCodes, setBudgetCodes] = useState([]);
    const [isAdd, setIsAdd] = useState(false);
    const [SKUCategoryNames, setSKUCategoryNames] = useState();
    const [warehouses, setWarehouses] = useState([]);
    const [storeWarehouses, setStoreWarehouses] = useState([]);
    const [backConfirmation, setBackConfirmation] = useState(false);
    const [isExecuteButtonDisabled, setIsExecuteButtonDisabled] = useState(false);
    const [skuArray, setSkuArray] = useState([]);
    const [saveConfirmation, setSaveConfirmation] = useState(false);

    const [warehouseSKUMppingDetails, setWarehouseSKUMppingDetails] = useState({
        groupID: 0,
        factoryID: 0,
        budgetCodeID: 0,
        warehouseID: 0,
        skuMasterID: [],
        skuCategoryID: 0,
        purchaseCategoryID: 0,
        purchaseTypeID: 0,
    });

    const [selectedOptions, setSelectedOptions] = useState([]);
    const getOptionLabel = option => `${option.label}`;
    const getOptionDisabled = option => option.value === "foo";
    const handleToggleOption = selectedOptions =>
        setSelectedOptions(selectedOptions);
    const handleClearOptions = () => setSelectedOptions([]);
    const handleSelectAll = isSelected => {
        if (isSelected) {
            setSelectedOptions(skuArray);
        } else {
            handleClearOptions();
        }
    };

    const [mappingArray, setMappingArray] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isRegionFilterEnabled: false
    });

    useEffect(() => {
        trackPromise(getGroupsForDropdown(),
            getPermissions(),
            getBudgetCodeDetails(),
            getPurchaseCategoriesForDropdown(),
        );
    }, []);

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...warehouseSKUMppingDetails,
            factoryID: 0,
            warehouseID: 0,
            // defaultWarehouseID: 0,
            purchaseCategoryID: 0,
            purchaseTypeID: 0,
            // defaultWarehouseID: 0,
            budgetCodeID: 0,
            skuCategoryID: 0,

        })
        setSelectedOptions([])
    }, [warehouseSKUMppingDetails.groupID])

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...warehouseSKUMppingDetails,
            warehouseID: 0,
            // defaultWarehouseID: 0,
            budgetCodeID: 0,
            skuCategoryID: 0,

        })
        setSelectedOptions([]);
        setSKUCategoryNames([]); 
    }, [warehouseSKUMppingDetails.factoryID])

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...warehouseSKUMppingDetails,
            // defaultWarehouseID: 0,
            budgetCodeID: 0,
            skuCategoryID: 0,

        })
        setSelectedOptions([])
    }, [warehouseSKUMppingDetails.warehouseID])

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...warehouseSKUMppingDetails,
            // defaultWarehouseID: 0,
            budgetCodeID: 0,
            skuCategoryID: 0,

        })
        setSelectedOptions([])
    }, [warehouseSKUMppingDetails.purchaseCategoryID])

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...warehouseSKUMppingDetails,
            // defaultWarehouseID: 0,
            budgetCodeID: 0,
            skuCategoryID: 0,

        })
        setSelectedOptions([])
    }, [warehouseSKUMppingDetails.purchaseTypeID])

    // useEffect(() => {
    //     setWarehouseSKUMppingDetails({
    //         ...warehouseSKUMppingDetails,
    //         budgetCodeID: 0,
    //         skuCategoryID: 0,

    //     })
    //     setSelectedOptions([])
    // }, [warehouseSKUMppingDetails.defaultWarehouseID])

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...warehouseSKUMppingDetails,
            skuCategoryID: 0,

        })
        setSelectedOptions([])
    }, [warehouseSKUMppingDetails.budgetCodeID])

    useEffect(() => {
        setSelectedOptions([])
    }, [warehouseSKUMppingDetails.skuCategoryID])

    useEffect(() => {
        if (warehouseSKUMppingDetails.groupID > 0) {
            trackPromise(getfactoriesForDropDown());
        } else {
            setWarehouseSKUMppingDetails([])
        }
    }, [warehouseSKUMppingDetails.groupID]);

    useEffect(() => {
        if (warehouseSKUMppingDetails.factoryID > 0) {
            trackPromise(GetWarehouseForDropDown());
            trackPromise(GetStoreWarehouseForDropDown());
        }
    }, [warehouseSKUMppingDetails.factoryID]);

    const handleSaveConfirmation = () => {
        setSaveConfirmation(true);
    };

    const handleConfirmSaveWithConfirmation = () => {
        setSaveConfirmation(false);
        saveDetails();
    };

    const handleCancelSave = () => {
        setSaveConfirmation(false);
    };


    useEffect(() => {
        if (warehouseSKUMppingDetails.budgetCodeID > 0) {
            trackPromise(getSKUCategoryNamesForDropdown());
        };
    }, [warehouseSKUMppingDetails.budgetCodeID]);

    useEffect(() => {
        if (warehouseSKUMppingDetails.skuCategoryID > 0) {
            trackPromise(getSKUNamesForDropdown());
        };
    }, [warehouseSKUMppingDetails.skuCategoryID]);

    useEffect(() => {
        if (warehouseSKUMppingDetails.budgetCodeID == 0) {
            setWarehouseSKUMppingDetails((prev) => ({
                ...prev,
                skuCategoryID: 0
            }))
            setSKUCategoryNames([]);
        };
    }, [warehouseSKUMppingDetails.budgetCodeID]);

    useEffect(() => {
        if (warehouseSKUMppingDetails.budgetCodeID > 0 && warehouseSKUMppingDetails.factoryID > 0) {
            trackPromise(getSKUCategoryNamesForDropdown());
        };
    }, [warehouseSKUMppingDetails.budgetCodeID, warehouseSKUMppingDetails.factoryID]);

    useEffect(() => {
        if (warehouseSKUMppingDetails.skuCategoryID == 0) {
            setSkuArray([])
            setSelectedOptions([])
        };
    }, [warehouseSKUMppingDetails.skuCategoryID]);

    useEffect(() => {
        setIsExecuteButtonDisabled(false);
    }, [selectedOptions]);

    const handleClick = () => {
        navigate('/app/warehouseSkuMapping/listing');
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITWAREHOUSESKUMAPPING');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        var isRegionFilterEnabled = permissions.find(p => p.permissionCode == 'REGIONDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isRegionFilterEnabled: isRegionFilterEnabled !== undefined,
        });

        setWarehouseSKUMppingDetails({
            ...warehouseSKUMppingDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken()),
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getPurchaseCategoriesForDropdown() {
        const purchaseCategories = await services.getPurchaseCategoriesForDropdown();
        setPurchaseCategories(purchaseCategories);
    }

    async function getfactoriesForDropDown() {
        var response = await services.getfactoriesForDropDown(warehouseSKUMppingDetails.groupID);
        setFactories(response);
    }

    async function getBudgetCodeDetails() {
        var response = await services.getBudgetCodeDetails();
        setBudgetCodes(response);
    }

    async function GetWarehouseForDropDown() {
        const warehouses = await services.getWarehouseForDropDown(warehouseSKUMppingDetails.factoryID);
        setWarehouses(warehouses);
    }

    async function getSKUNamesForDropdown() {
        const sku = await services.GetSKUNamesByCategoryID(warehouseSKUMppingDetails.skuCategoryID);
        const validSkuEntries = Object.entries(sku).filter(([key, value]) => key && value);
        const newSkuArray = validSkuEntries.map(([key, value]) => ({
            value: key,
            label: value
        }));
        setSkuArray(newSkuArray);
        setSelectedOptions([]);
    }

    async function getSKUCategoryNamesForDropdown() {
        const SKUCategoryNames = await services.GetSKUCategoryNamesByBudjetID(
            warehouseSKUMppingDetails.budgetCodeID,
            warehouseSKUMppingDetails.groupID,
            warehouseSKUMppingDetails.factoryID
        );
        setSKUCategoryNames(SKUCategoryNames);
    }

    async function GetStoreWarehouseForDropDown() {
        const storeWarehouses = await services.GetStoreWarehouseForDropDown(warehouseSKUMppingDetails.groupID);
        setStoreWarehouses(storeWarehouses);
    }

    function clearData() {
        setWarehouseSKUMppingDetails({
            ...warehouseSKUMppingDetails,
            groupID: 0,
            factoryID: 0,
            budgetCodeID: 0,
            skuCategoryID: 0,
            skuMasterID: [],
            warehouseID: 0,
            purchaseCategoryID: 0,
            purchaseTypeID: 0,
            // defaultWarehouseID: 0,
        });
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setWarehouseSKUMppingDetails(prev => {

            const updatedState = { ...prev, [name]: value };

            if (name === 'purchaseCategoryID') {
                if (value === "2") {
                    updatedState.purchaseTypeID = "1";
                }
                else if (value === "1") {
                    updatedState.purchaseTypeID = "0";
                }
            }

            return updatedState;
        });
    };

    async function AddMappingDetails() {
        setIsExecuteButtonDisabled(true);
        if (selectedOptions.length === 0) {
            alert.error("Please select at least one SKU.");
            return;
        }

        const baseModel = {
            groupID: parseInt(warehouseSKUMppingDetails.groupID),
            factoryID: parseInt(warehouseSKUMppingDetails.factoryID),
            warehouseID: parseInt(warehouseSKUMppingDetails.warehouseID),
            skuCategoryID: parseInt(warehouseSKUMppingDetails.skuCategoryID),
            // defaultWarehouseID: parseInt(warehouseSKUMppingDetails.defaultWarehouseID),
            purchaseCategoryID: parseInt(warehouseSKUMppingDetails.purchaseCategoryID),
            budgetCodeID: parseInt(warehouseSKUMppingDetails.budgetCodeID),
            skuCategoryID: parseInt(warehouseSKUMppingDetails.skuCategoryID)
        };
        const newMappings = [];
        const existingSkus = new Set();

        for (const skuOption of selectedOptions) {
            const skuMasterID = parseInt(skuOption.value);
            const skuModel = { ...baseModel, skuMasterID };

            const response = await services.GetExestingMappingDetail(skuModel);
            if (response.data != null) {
                if (response.data.warehouseSKUMappingID > 0) {
                    existingSkus.add(skuOption.label);
                    continue;
                }
            }

            const isLocalDuplicate = mappingArray.some(item =>
                item.warehouseID === baseModel.warehouseID &&
                item.skuMasterID === skuMasterID
            );

            if (isLocalDuplicate) {
                existingSkus.add(skuOption.label);
                continue;
            }

            newMappings.push({
                ...baseModel,
                skuMasterID: skuMasterID,
                skuMasterName: skuOption.label,
                factoryID: warehouseSKUMppingDetails.factoryID ? parseInt(warehouseSKUMppingDetails.factoryID) : 0,
                factoryName: parseInt(warehouseSKUMppingDetails.factoryID) > 0 ? factories[warehouseSKUMppingDetails.factoryID] : '',
                warehouseName: warehouses[warehouseSKUMppingDetails.warehouseID],
                skuCategoryName: SKUCategoryNames[warehouseSKUMppingDetails.skuCategoryID],
                purchaseCategoryName: purchaseCategories[baseModel.purchaseCategoryID],
                createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
                createdDate: new Date().toISOString()
            });
        }

        if (existingSkus.size > 0) {
            alert.error(`These SKUs already exist: ${Array.from(existingSkus).join(', ')}`);
        }

        if (newMappings.length > 0) {
            setMappingArray(prev => [...prev, ...newMappings]);

            setSkuArray([]);
            setSelectedOptions([]);
            setWarehouseSKUMppingDetails(prev => ({
                ...prev,
                skuCategoryID: 0
            }));
        }
        setIsExecuteButtonDisabled(false);
    }

    const DeleteDetails = (row, index) => {
        const updatedArray = mappingArray.filter((_, i) => i !== index);
        setMappingArray(updatedArray);
    };

    async function ClearData() {
        setWarehouseSKUMppingDetails((prevent) => ({
            ...prevent,
            warehouseID: 0,
            skuCategoryID: 0,
            purchaseCategoryID: 0,
            purchaseTypeID: 0,
            // defaultWarehouseID: 0,
            budgetCodeID: 0,
        }));
    }

    async function saveDetails() {
        if (mappingArray.length > 0) {
            var response = await services.SaveMappingDetails(mappingArray);
            if (response.statusCode == "Success") {
                alert.success(response.message);
                setMappingArray([]);
                ClearData();
                handleClick();
            }
            else {
                alert.error(response.message);
                ClearData();
            }
        }
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleConfirmBackOne}
                    />
                </Grid>
            </Grid>
        )
    }

    function handleConfirmBack() {
        setBackConfirmation(false)
    }

    function handleConfirmBackOpen() {
        setBackConfirmation(true)
    }

    function handleConfirmBackOne() {
        if (mappingArray.length != 0) {
            handleConfirmBackOpen()
        }
        else {
            handleClick()
        }
    }

    const handleConfirmBackTwo = () => {
        setBackConfirmation(false);
        navigate('/app/warehouseSkuMapping/listing');
    }

    const handleConfirmSave = () => {
        setBackConfirmation(false);
        saveDetails();
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title={title}
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: warehouseSKUMppingDetails.groupID,
                            factoryID: warehouseSKUMppingDetails.factoryID,
                            budgetCodeID: warehouseSKUMppingDetails.budgetCodeID,
                            skuMasterID: warehouseSKUMppingDetails.skuMasterID,
                            skuCategoryID: warehouseSKUMppingDetails.skuCategoryID,
                            warehouseID: warehouseSKUMppingDetails.warehouseID,
                            // defaultWarehouseID: warehouseSKUMppingDetails.defaultWarehouseID,
                            purchaseCategoryID: warehouseSKUMppingDetails.purchaseCategoryID,
                        }}

                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
                                budgetCodeID: Yup.number().required('Account Code Name is required').min("1", 'Account Code Name is required'),
                                skuCategoryID: Yup.number().required('SKU Category is required').min("1", 'SKU Category is required'),
                                warehouseID: Yup.number().required('Warehouse is required').min("1", 'Warehouse is required'),
                                //defaultWarehouseID: Yup.number().required('Store Warehouse is required').min("1", 'Store Warehouse is required'),
                                purchaseCategoryID: Yup.number().required('Purchase Category is required').min("1", 'Purchase Category is required'),
                            })
                        }
                        onSubmit={AddMappingDetails}

                        enableReinitialize
                        validateOnBlur={false}
                        validateOnChange={false}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={2}>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={warehouseSKUMppingDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled || isAdd,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            size='small'
                                                            name="factoryID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={warehouseSKUMppingDetails.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            InputProps={{ readOnly: !permissionList.isFactoryFilterEnabled }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="warehouseID">
                                                            Warehouse *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.warehouseID && errors.warehouseID)}
                                                            fullWidth
                                                            helperText={touched.warehouseID && errors.warehouseID}
                                                            name="warehouseID"
                                                            size='small'
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={warehouseSKUMppingDetails.warehouseID}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="0">--Select Warehouse--</MenuItem>
                                                            {generateDropDownMenu(warehouses)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="purchaseCategoryID">
                                                            Purchase Category *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.purchaseCategoryID && errors.purchaseCategoryID)}
                                                            fullWidth
                                                            helperText={touched.purchaseCategoryID && errors.purchaseCategoryID}
                                                            name="purchaseCategoryID"
                                                            size='small'
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={warehouseSKUMppingDetails.purchaseCategoryID}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="0">--Select Purchase Category--</MenuItem>
                                                            {generateDropDownMenu(purchaseCategories)}
                                                        </TextField>
                                                    </Grid>
                                                    {/* <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="defaultWarehouseID">
                                                            Store Warehouse *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.defaultWarehouseID && errors.defaultWarehouseID)}
                                                            fullWidth
                                                            helperText={touched.defaultWarehouseID && errors.defaultWarehouseID}
                                                            name="defaultWarehouseID"
                                                            size='small'
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={warehouseSKUMppingDetails.defaultWarehouseID}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="0">--Select Store Warehouse--</MenuItem>
                                                            {generateDropDownMenu(storeWarehouses)}
                                                        </TextField>
                                                    </Grid> */}
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="budgetCodeID">
                                                            Account Code Name *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.budgetCodeID && errors.budgetCodeID)}
                                                            fullWidth
                                                            helperText={touched.budgetCodeID && errors.budgetCodeID}
                                                            size='small'
                                                            name="budgetCodeID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={warehouseSKUMppingDetails.budgetCodeID}
                                                            variant="outlined"
                                                            id="budgetCodeID"
                                                        >
                                                            {generateDropDownMenu(budgetCodes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="skuCategoryID">
                                                            SKU Category *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.skuCategoryID && errors.skuCategoryID)}
                                                            fullWidth
                                                            helperText={touched.skuCategoryID && errors.skuCategoryID}
                                                            size='small'
                                                            name="skuCategoryID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={warehouseSKUMppingDetails.skuCategoryID}
                                                            variant="outlined"
                                                            id="skuCategoryID"
                                                        >
                                                            <MenuItem value="0">--Select SKU Category--</MenuItem>
                                                            {generateDropDownMenu(SKUCategoryNames)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="skuMasterID">
                                                            SKU *
                                                        </InputLabel>
                                                        <CustomMultiSelect
                                                            error={Boolean(touched.skuMasterID && errors.skuMasterID)}
                                                            helperText={touched.skuMasterID && errors.skuMasterID}
                                                            items={skuArray}
                                                            getOptionLabel={getOptionLabel}
                                                            getOptionDisabled={getOptionDisabled}
                                                            selectedValues={selectedOptions}
                                                            placeholder="--Select SKU--"
                                                            selectAllLabel="Select All"
                                                            onToggleOption={handleToggleOption}
                                                            onClearOptions={handleClearOptions}
                                                            onSelectAll={handleSelectAll}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container justify="flex-end" spacing={3}>
                                                    <Box pr={2} style={{ marginTop: '20px' }}>
                                                        <Button
                                                            color="primary"
                                                            variant="outlined"
                                                            type="reset"
                                                            onClick={clearData}
                                                            size='small'
                                                        >
                                                            Clear
                                                        </Button>
                                                    </Box>
                                                    <Box pr={2} style={{ marginTop: '20px' }}>
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            type="submit"
                                                            size='small'
                                                            disabled={isExecuteButtonDisabled}
                                                        >
                                                            {"Add"}
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </CardContent>
                                            {mappingArray.length > 0 ? (
                                                <Grid item xs={12}>
                                                    <TableContainer style={{ maxHeight: 400, overflowY: 'auto' }}>
                                                        <Table className={classes.table} aria-label="caption table" stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left"><b>FactoryName</b></TableCell>
                                                                    <TableCell align="left"><b>Warehouse</b></TableCell>
                                                                    <TableCell align="left"><b>SKU Category</b></TableCell>
                                                                    <TableCell align="left"><b>SKU Name</b></TableCell>
                                                                    <TableCell align="left"><b>Purchase Category</b></TableCell>
                                                                    <TableCell align="center"><b>Action</b></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {mappingArray.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell align="left">{row.factoryName}</TableCell>
                                                                        <TableCell align="left">{row.warehouseName}</TableCell>
                                                                        <TableCell align="left">{row.skuCategoryName}</TableCell>
                                                                        <TableCell align="left">{row.skuMasterName}</TableCell>
                                                                        <TableCell align="left">{row.purchaseCategoryName}</TableCell>
                                                                        <TableCell align="center" style={{ borderBottom: "none" }}>
                                                                            <DeleteIcon
                                                                                style={{
                                                                                    color: "red",
                                                                                    marginBottom: "-1rem",
                                                                                    marginTop: "0rem",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                                size="small"
                                                                                onClick={() => DeleteDetails(row, index)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            )
                                                : null}
                                            {(mappingArray.length > 0) ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="button"
                                                        variant="contained"
                                                        size='small'
                                                        onClick={handleSaveConfirmation}
                                                    >
                                                        {"Save"}
                                                    </Button>
                                                </Box>
                                                : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
                <Dialog open={saveConfirmation}>
                    <DialogTitle id="alert-dialog-save-title">
                        <Typography
                            color="textSecondary"
                            gutterBottom
                            variant="h3">
                            <Box textAlign="center">
                                Save Confirmation
                            </Box>
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-save-description">
                            <Typography variant="h5">Are you sure you want to save the data?</Typography>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleConfirmSaveWithConfirmation} color="primary">
                            Yes
                        </Button>
                        <Button onClick={handleCancelSave} color="primary" autoFocus>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={backConfirmation}>
                    <DialogTitle id="alert-dialog-slide-title">
                        <Typography
                            color="textSecondary"
                            gutterBottom
                            variant="h3">
                            <Box textAlign="center">
                                Confirmation
                            </Box>
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            <Typography variant="h5">Are you sure do you want to go  back without saving?</Typography>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <br />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleConfirmBackTwo} color="primary">
                            Yes
                        </Button>
                        <Button
                            onClick={handleConfirmBack} color="primary" autoFocus>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </Page >
        </Fragment >
    )
}
